module.exports = "/images/MG.png?99cd2f770ee15075f55575781b649662";